import React, { PureComponent } from 'react';
import { getSignalDelay } from '@/services/Sierra/results';
import { connect } from 'react-redux';
import makeCancelable from '@/services/api/makeCancelable';
import DelayComp, { sortDelayData, delayColumn } from '../components/Delay';
import { SweepResultData } from '@/services/Sierra';
import { COMP_REPEATER } from '../../../../constants/componentType';

class DelayResult extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      resultList: [],
    }
  }

  componentDidMount = () => {
    const { sweepId } = this.props;
    if (sweepId) {
      this.getData()
    }
  }

  componentDidUpdate = (prevProps) => {
    const { sweepListStatus, expKeyStatus } = this.props;
    if (sweepListStatus && sweepListStatus !== prevProps.sweepListStatus) {
      this.getData()
      this.props.updateSweepListStatus(false)
    } else if (expKeyStatus && expKeyStatus !== prevProps.expKeyStatus) {
      this.getData(true)
      this.props.updateExpKeyStatus(false)
    }
  }

  getData = (keep = false) => {
    const newResultList = keep ? this.keepResult() : this.props.resultList;
    this.setState({
      resultList: JSON.parse(JSON.stringify(newResultList))
    }, () => {
      this.getDelayData();
    })
  }

  keepResult = () => {
    let newResultList = JSON.parse(JSON.stringify(this.props.resultList));
    const { resultList } = this.state;
    return newResultList.map(item => {
      const current = resultList.find(r => r.id === item.id);
      return current ? current : item
    })
  }

  getDelayData = async () => {
    const { currentProjectId } = this.props;
    const { resultList } = this.state;
    const newResultList = [];
    for (let exp of resultList) {
      if (exp.delayData && exp.delayData.length) {
        newResultList.push({ ...exp });
        continue;
      }
      let hasRepeater = false;
      try {
        const res = await SweepResultData.getVerificationJsonPromise(exp.id, currentProjectId);
        let designs = [];
        if (res) {
          let currentInterfaces = SweepResultData.getInterfaces(exp.id);
          const config = SweepResultData.getConfig(exp.id);
          const isHSpice = config && config.simulate === "HSPICE";
          currentInterfaces.forEach(item => {
            designs.push({
              id: item.pcbId,
              name: item.pcb
            });
            if (isHSpice && item.content && item.content.components && item.content.components.find(it => it.type === COMP_REPEATER)) {
              hasRepeater = true;
            }
          })

          const promise = getSignalDelay({ experimentId: exp.id, designs, projectId: currentProjectId })
          this.cancelable = makeCancelable(promise);
          const response = await this.cancelable.promise;
          const delay = response;
          newResultList.push({ ...exp, delayData: sortDelayData(delay, currentInterfaces), errorMsg: delay && delay.length ? "" : "HSPICE does not support calculating delay results with repeater components." });
        }
      } catch (error) {
        newResultList.push({ ...exp, delayData: [], errorMsg: hasRepeater ? "HSPICE does not support calculating delay results with repeater components." : "" });
        console.error(error);
      }
    }
    this.setState({
      resultList: newResultList
    }, () => {
      this.DelayDataHandle(newResultList)
    })
  }

  DelayDataHandle = (resultList) => {
    let _delayData = [], childrenColumns = [], column = [], errorMsg = "";
    if (resultList.length < 2) {
      _delayData = resultList[0] ? resultList[0].delayData : [];
      errorMsg = resultList[0] ? resultList[0].errorMsg : "";
    } else {
      for (let i = 0; i < resultList.length; i++) {
        const delayData = resultList[i].delayData;
        if (!_delayData.length && delayData) {
          delayData.forEach(item => {
            const { netName, driver, receiver, delay } = item;
            _delayData.push({ netName, driver, receiver, [`delay_${i}`]: delay })
          })
        } else if (delayData) {
          delayData.forEach((item, index) => {
            const { delay } = item;
            _delayData[index][`delay_${i}`] = delay;
          })
        }
        childrenColumns.push({
          title: resultList[i].name,
          dataIndex: `delay_${i}`,
          key: `delay_${i}`,
          render: (text) => {
            return <span>{text}</span>
          },
          onCell: (record) => {
            return {
              className: 'sweep-delay-table-td'
            }
          }
        })
        errorMsg = resultList[i].errorMsg;
      }
      column = JSON.parse(JSON.stringify(delayColumn));
      column[0].children = childrenColumns;
    }
    this.setState({
      delayData: _delayData,
      column,
      errorMsg
    })
  }

  render() {
    const { delayData, column, errorMsg } = this.state;
    return DelayComp({ delayData, key: 'Delay', column, errorMsg });
  }
}

const mapState = (state) => {
  const { project, sweep: { experimentInfo } } = state.SierraReducer;
  const { currentProjectId } = project;
  const { id = "" } = experimentInfo;
  return {
    currentProjectId,
    sweepId: id
  }
}

const mapDispatch = (dispatch) => ({
})

export default connect(mapState, mapDispatch)(DelayResult);